import * as React from 'react'

interface Props {
    value: string // "HH:MM" 24h format
    onChange: (value: string) => void
    label?: string
    disabled?: boolean
    large?: boolean
}

export const TimePicker: React.FC<Props> = (props) => {
    const { value, onChange, label, disabled, large } = props

    const parseValue = (val: string) => {
        if (!val) return { hour: 12, minute: 0, period: 'AM' as const }
        const [h, m] = val.split(':').map(Number)
        const period = h >= 12 ? 'PM' as const : 'AM' as const
        const hour = h === 0 ? 12 : h > 12 ? h - 12 : h
        return { hour, minute: m, period }
    }

    const { hour, minute, period } = parseValue(value)

    const to24 = (h: number, m: number, p: string): string => {
        let h24 = h
        if (p === 'AM' && h === 12) h24 = 0
        else if (p === 'PM' && h !== 12) h24 = h + 12
        return `${String(h24).padStart(2, '0')}:${String(m).padStart(2, '0')}`
    }

    const handleHour = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(to24(Number(e.target.value), minute, period))
    }
    const handleMinute = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(to24(hour, Number(e.target.value), period))
    }
    const handlePeriod = (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange(to24(hour, minute, e.target.value))
    }

    const hours = Array.from({ length: 12 }, (_, i) => i + 1)
    const minutes = Array.from({ length: 12 }, (_, i) => i * 5)

    const sizeClass = large ? 'select-md text-lg' : 'select-sm'
    const selectClass = `select select-bordered select-primary ${sizeClass} text-center focus:outline-none focus:ring-0 focus:shadow-none focus:border-primary flex-1`
    const labelClass = large ? 'text-lg font-semibold' : 'text-sm font-semibold'
    const colonClass = large ? 'text-2xl font-bold' : 'text-lg font-bold'

    return (
        <div className={'flex flex-col gap-1 items-center w-full'}>
            {label && <label className={labelClass}>{label}</label>}
            <div className={'flex gap-2 items-center justify-center w-full'}>
                <select className={selectClass} value={hour} onChange={handleHour} disabled={disabled}>
                    {hours.map(h => (
                        <option key={h} value={h}>{h}</option>
                    ))}
                </select>
                <span className={colonClass}>:</span>
                <select className={selectClass} value={minute} onChange={handleMinute} disabled={disabled}>
                    {minutes.map(m => (
                        <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
                    ))}
                </select>
                <select className={selectClass} value={period} onChange={handlePeriod} disabled={disabled}>
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                </select>
            </div>
        </div>
    )
}
